import React from 'react';
import { FullPageLoader } from 'shared/components/loading';
import { useGetMenuCustomization } from '../data-access';
import { ExtensionsForm } from './extensions-form';

export default function Extensions(): JSX.Element | null {
  const { data, loading } = useGetMenuCustomization();

  if (loading) {
    return <FullPageLoader />;
  }

  const remoteExtensions = data?.remoteExtensions
    ? {
        theme: {
          extensionData: data.remoteExtensions.theme?.extensionData ?? [],
          manifestUrl: data.remoteExtensions.theme?.manifestUrl ?? '',
          modulePath: data.remoteExtensions.theme?.modulePath ?? '',
          scope: data.remoteExtensions.theme?.scope ?? '@dutchie/customer-themes',
        },
      }
    : undefined;

  return <ExtensionsForm remoteExtensions={remoteExtensions} />;
}
